const SUBGRAPH_URL = "https://api.studio.thegraph.com/query/60571/voidex-base-sepolia/v0.0.6";

export async function querySubgraph<T>(
	query: string,
	variables?: Record<string, unknown>,
): Promise<T> {
	const res = await fetch(SUBGRAPH_URL, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ query, variables }),
	});

	if (!res.ok) {
		throw new Error(`Subgraph query failed: ${res.status}`);
	}

	const json = await res.json();

	if (json.errors) {
		throw new Error(`Subgraph error: ${json.errors[0]?.message}`);
	}

	return json.data as T;
}
